import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ISearchValue {
   value: string;
}

const initialState: ISearchValue = {
   value: ""
}

export const searchValueSlice = createSlice({
   name: "searchValue",
   initialState: initialState,
   reducers: {
      setSearchValue: (state, action: PayloadAction<string>) => {
         state.value = action.payload;
      },
   },
});

export const { setSearchValue } = searchValueSlice.actions;
export const getSearchvalueStatus = (state: any) => state.searchValue.value;
export default searchValueSlice.reducer;
